module.exports = __webpack_public_path__ + "static/media/asset_website_UI.66c7c1fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Features/Watch/img/asset_website_UI.png
// module id = 175
// module chunks = 0